import VerifiedIcon from '@mui/icons-material/Verified';
import {
  Alert,
  Button,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useState } from 'react';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const BusinessStateColorado = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Colorado Business Tax Filing Requirements | TaxZerone"
          description="Learn about Colorado business tax filing with TaxZerone. Get step-by-step guidance to stay compliant, file accurately, and avoid penalties with the DOR."
          keywords=" "
          canonical="business-tax/state-filing/colorado-tax-filing-requirements/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <BusinessTaxSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/colorado-business-tax-img.webp" />
                <source srcSet="/assets/images/colorado-business-tax-img.png" />
                <img
                  src="/assets/images/colorado-business-tax-img.png"
                  alt="Colorado Business Tax Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">Colorado </span>
                </span>{' '}
                Business Tax Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Understand what taxes your Colorado business owes, when to file,
                and how to pay—so you can avoid penalties and focus on growth
                with confidence.
              </Typography>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/colorado-business-tax-img-sm.webp" />
                <source srcSet="/assets/images/colorado-business-tax-img-sm.png" />
                <img
                  src="/assets/images/colorado-business-tax-img-sm.png"
                  alt="Colorado Business Tax Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            What are the Business Tax Forms in Colorado?
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            The forms your business needs to file in Colorado depend on your
            business structure and activities. Here’s a detailed guide:
          </Typography>

          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/single-member-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/single-member-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/single-member-icon.png"
                    alt="Sole Proprietorship & Single-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sole Proprietorship & <br /> Single-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR_0104_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0104
                        </Link>{' '}
                        –
                      </span>{' '}
                      Individual Income Tax Return
                    </li>

                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-prior/f1040sc--2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Schedule C
                        </Link>{' '}
                        (Federal Form 1040) -
                      </span>{' '}
                      Profit or Loss from Business (reported on Form 104)
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/Partnership-income-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/Partnership-income-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/Partnership-income-icon.png"
                    alt="Partnership & Multi-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Partnership & Multi-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0106_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0106
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Partnership & S Corporation Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0106K_2024_2.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0106K
                        </Link>{' '}
                        –
                      </span>{' '}
                      Colorado K-1 (for partners/shareholders).
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0107_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0107
                        </Link>{' '}
                        –
                      </span>{' '}
                      Colorado Nonresident Partner or Shareholder Agreement.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0900_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0900P
                        </Link>{' '}
                        –
                      </span>{' '}
                      Partnership & S Corporation Income Tax Payment Form.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0900_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0106EP
                        </Link>{' '}
                        –
                      </span>{' '}
                      Composite Nonresident Estimated Tax Payment Form.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0106CR_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0106CR
                        </Link>{' '}
                        –
                      </span>{' '}
                      Pass-Through Entity Credit Schedule
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR_0108_2023.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0108
                        </Link>{' '}
                        –
                      </span>{' '}
                      Statement of Colorado Tax Remittance for Nonresident
                      Partner/Shareholder
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/c-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/c-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/c-corporation-icon.png"
                    alt="C Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0106EP_2025.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0112
                        </Link>{' '}
                        –
                      </span>{' '}
                      Colorado Corporation Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0112C_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0112C
                        </Link>{' '}
                      </span>{' '}
                      <i> Schedule C:</i> Colorado Affiliations Schedule
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0112X_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0112X
                        </Link>{' '}
                      </span>{' '}
                      Amended Return for C Corporations
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0112EP_2025.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          DR 0112-EP
                        </Link>{' '}
                      </span>{' '}
                      Estimated Tax Payment Voucher for Corporations
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0112CR_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0112CR
                        </Link>{' '}
                      </span>{' '}
                      Credit Schedule for Corporations
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/s-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/s-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/s-corporation-icon.png"
                    alt="S Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0106_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0106
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0106K_2024_2.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0106K
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Shareholder Credit Schedule
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0106EP_2025.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0106EP
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Composite Nonresident Estimated Payment
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0106CR_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0106CR
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Pass-Through Credit Schedule
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/business-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/business-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/business-tax-icon.png"
                    alt="Pass-Through Entities"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Pass-Through Entities
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR_0108_2023.pdf"
                          sx={{ color: '#0202ff' }}
                          target="_blank"
                        >
                          {' '}
                          Form DR 0108
                        </Link>{' '}
                        –
                      </span>{' '}
                      Statement of Colorado Tax Remittance for Nonresident
                      Partners/Shareholders
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0107_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0107
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Nonresident Partner or Shareholder Agreement
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/withholding-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/withholding-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/withholding-tax-icon.png"
                    alt="Tax-Exempt Organizations"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Tax-Exempt Organizations
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR_0990_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 0990
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Exempt Entity Income Tax Credit Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/property-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/property-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/property-icon.png"
                    alt="Employment & Payroll Tax Forms"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Employment & Payroll Tax Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/CR0100_2025.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form CR 0100
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Colorado Sales Tax and Withholding Account Application
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR_0004_2025.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0004
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Employee Withholding Certificate
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR_1093_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 1093
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Annual Transmittal of State W-2 Forms
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR%201094_e_wo.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 1094
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Colorado W-2 Wage Withholding Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 0, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/property-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/property-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/property-icon.png"
                    alt="Additional Colorado Business Tax Forms "
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Additional Colorado Business Tax Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/DR0100"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0100
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Retail Sales and Use Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR0145_2023.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0145
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Power of Attorney / Tax Information Authorization
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/DR0096_2013.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 0096
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Request for Tax Status Letter
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR1102_07-2022.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 1102
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Address or Name Change Form
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://tax.colorado.gov/sites/tax/files/documents/DR_1108_2022.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DR 1108
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Business Tax Account Closure Form
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column' }}
          sx={{ pt: 2, pb: 2, justifyContent: 'center', mb: 2 }}
        >
          <Grid
            size={12}
            sx={{
              textAlign: { md: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'center', sm: 'center' },
                }}
              >
                What are the deadlines for the Business Tax Forms in Colorado?
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: { lg: 18, md: 16, sm: 14, xs: 14 }, mb: 3 }}
              >
                Understand the key deadlines for filing Colorado business taxes
                for all entity types:
              </Typography>
            </Box>
          </Grid>
          <Grid size={12} justifyContent="center">
            <Box
              component="div"
              sx={{
                mb: 0,
                maxWidth: 800,
                justifyContent: 'center',
                alignItems: 'center',
                m: 'auto',
              }}
            >
              <TableContainer
                sx={{ border: '1px solid #828282', borderRadius: 2 }}
              >
                <Table sx={{}} aria-label="Due Date Chart">
                  <TableBody>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Sole Proprietorship & Single-Member LLC
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: '1px solid #828282',
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        April 15
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        April 15
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Partnerships & Multi-Member LLCs
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: '1px solid #828282',
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 4<sup>th</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        April 15
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        C Corporations
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 5<sup>th</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        May 15
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        S Corporations
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 4<sup>th</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        April 15
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Pass-Through Entities
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        April 15
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        April 15
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Tax-Exempt Organizations
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15<sup>th</sup> day of 5<sup>th</sup> month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                          fontSize: 16,
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        May 15
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Employment & Payroll Tax Forms
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        <ul>
                          <li style={{ marginBottom: 8, fontSize: 16 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Monthly filers:
                            </span>{' '}
                            15th day of the following month
                          </li>
                          <li>
                            <span style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              Quarterly filers:
                            </span>{' '}
                            Last day of the month following the quarter (e.g.,
                            April 30, July 31, October 31, January 31)
                          </li>
                          <li>
                            <span style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              Annual filers:
                            </span>{' '}
                            January 31 following the tax year
                          </li>
                        </ul>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          // borderBottom: '1px solid #828282',
                        }}
                      >
                        Sales & Use Tax Returns
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          // borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        <ul>
                          <li style={{ marginBottom: 8, fontSize: 16 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Monthly filers:
                            </span>{' '}
                            20th day of the following month
                          </li>
                          <li style={{ marginBottom: 0 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Quarterly filers:
                            </span>{' '}
                            April 20, July 20, October 20, January 20
                          </li>
                          <li style={{ marginBottom: 0 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Annual filers:
                            </span>{' '}
                            January 20 following the reporting year
                          </li>
                        </ul>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Alert
              severity="info"
              id="who"
              icon={false}
              sx={{
                mt: 3,
                mb: 0,
                borderLeft: '3px solid #0288d1',
                textAlign: 'left',
                maxWidth: 800,
                mx: 'auto',
              }}
            >
              <span style={{ fontWeight: 600 }}> Important Reminder:</span> An
              extension grants you extra time to file your return,{' '}
              <span style={{ fontWeight: 600 }}> not</span> to pay your taxes.
              All taxes owed must be paid by the original due date to avoid
              penalties and interest.
            </Alert>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What Business Extension Forms are required in Colorado?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 0, fontSize: 20, fontWeight: 600 }}
                >
                  Entity Type
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    mb: 3,
                    mr: 2,
                    ml: -3,
                    listStyleType: 'none',
                    '& li': { mb: 1.5 },
                  }}
                >
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      C Corporation{' '}
                      <Link
                        href="https://tax.colorado.gov/sites/tax/files/documents/DR0158-C_2024.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form DR 0158-C
                      </Link>
                    </Box>
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Partnerships & S Corporation{' '}
                      <Link
                        href="https://tax.colorado.gov/sites/tax/files/documents/DR0158-N_2024.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Form DR 0158-N
                      </Link>
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Pass- Through Entities{' '}
                      <Link
                        href="https://tax.colorado.gov/sites/tax/files/documents/DR0158-N_2024.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form DR 0158-N{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Individuals/ Sole Proprietors{' '}
                      <Link
                        href="https://tax.colorado.gov/sites/tax/files/documents/DR0158-I_2024.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form DR 0158-I{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Tax Exempt Organization{' '}
                      <Link
                        href="https://tax.colorado.gov/sites/tax/files/documents/DR0158-F_2024.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form DR 0158-F{' '}
                      </Link>
                    </Box>{' '}
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{ fontSize: { md: 22, sm: 18, xs: 16 }, fontWeight: 600 }}
                >
                  Electronic Payment Option
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Colorado business tax payments can also be made online using
                  <span style={{ fontWeight: 600 }}> Revenue Online</span> (no
                  registration required):{' '}
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note: </b> TaxZerone supports{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    filing Form 7004
                  </Link>{' '}
                  for federal business tax extensions and offers step-by-step
                  guidance for{' '}
                  <span style={{ fontWeight: 600 }}>
                    Colorado state extension forms
                  </span>{' '}
                  (DR 0158-C, DR 0158-N, and DR 0158-F).
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              {/* <Link href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"> */}
              <Box
              // sx={{
              //   '&:hover': {
              //     transform: 'scale(1.02)',
              //   },
              //   '& .img-responsive:hover': {
              //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              //   },
              //   transition: 'transform 0.3s ease-in-out',
              // }}
              >
                <picture>
                  <source srcSet="/assets/images/colorado-extension-form-img.webp" />
                  <source srcSet="/assets/images/colorado-extension-form-img.png" />
                  <img
                    src="/assets/images/colorado-extension-form-img.png"
                    alt="What Business Extension Forms are required in Colorado?"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                    style={{ borderRadius: 24 }}
                  />
                </picture>
              </Box>
              {/* </Link> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center" mb={3}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                What are the Extended due date for Business Tax
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                Forms in Colorado?
              </Typography>
              {/* <Typography variant="body1" sx={{ mb: 3, fontSize: 18 }}>
                Understand the key{' '}
                <span style={{ fontWeight: 600 }}> extended deadlines</span> for
                filing Connecticut business taxes for all entity types:
              </Typography> */}
              <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Sole Proprietorship & Single-Member LLC
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 10<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 3,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Partnerships & Multi-Member LLCs
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 10<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      C Corporations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 11<sup>th</sup> month
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      S Corporations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 10<sup>th</sup> month
                    </Typography>
                  </Paper>{' '}
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Pass-Through Entities
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 10<sup>th</sup> month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Tax-Exempt Organizations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> Day
                      </Box>
                      <br />
                      of 11<sup>th</sup> month
                    </Typography>
                  </Paper>
                </Stack>
              </Box>
              {/* <Alert
                severity="warning"
                icon={false}
                sx={{ mb: 0, mt: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
              >
                <b>Note: </b> If the due date falls on a Saturday, Sunday, or
                legal holiday, the return is considered timely if filed on the
                next business day.
              </Alert> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          mb: 5,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container
          maxWidth="xl"
          sx={{
            mb: 5,
            '& .card__content': {
              animation: 'scale linear forwards',
              animationTimeline: 'view()',
              animationRange: '85vh 100vh',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 640, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(210, 186, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Stack
              spacing={2}
              direction={{ md: 'row', xs: 'column' }}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  textAlign: 'left',
                  alignItems: 'left',

                  justifyContent: 'left',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  Colorado Business Tax Extension Filing Requirements
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  To qualify for a business tax extension in Colorado, your
                  business must:
                </Typography>
                <Box sx={{ maxWidth: 'auto', textAlign: 'left' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      mr: 2,
                      listStyleType: 'none',
                      '& li': { mb: 2, fontSize: { md: 17, sm: 16, xs: 14 } },
                    }}
                  >
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          File or pay by the original due date
                        </span>{' '}
                        to avoid late payment penalties and interest.
                      </Box>
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Submit the appropriate extension form
                        </span>{' '}
                        based on your business entity type (Form DR 0158-C, DR
                        0158-N, or DR 0158-F).
                      </Box>{' '}
                    </li>

                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Estimate and pay any taxes owed
                        </span>{' '}
                        by the original due date — extensions only apply to
                        filing, not to payment.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Meet the 6-month automatic extension period,
                        </span>{' '}
                        which typically extends your deadline to{' '}
                        <span style={{ fontWeight: 600 }}> October 15</span> (or
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          November 15
                        </span>{' '}
                        for C corporations and exempt organizations).
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Keep copies of all filed forms and payment
                          confirmations
                        </span>{' '}
                        from the Colorado Department of Revenue for your
                        records.
                      </Box>{' '}
                    </li>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box sx={{}}>
                  <picture>
                    <source
                      srcSet="/assets/images/colorado-state-img.webp"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <source
                      srcSet="/assets/images/colorado-state-img.png"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <img
                      src="/assets/images/colorado-state-img.png"
                      loading="lazy"
                      alt="business tax extension in Colorado"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                  </picture>
                </Box>
              </Box>
            </Stack>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 640, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(244, 237, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: 'container' }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                <Box
                  component="div"
                  sx={{
                    mb: 3,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 1,
                    }}
                  >
                    Colorado Business Tax Rates
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 1,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 400,
                      textAlign: 'center',
                    }}
                  >
                    Business tax rates vary depending on your entity type:
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    C Corporation{' '}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    4.4%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    of net income (flat corporate income tax rate)
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Pass-Through
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    income is not taxed at the corporate level; shareholders
                    report income on individual returns
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    LLCs (Single- Member & Multi-Member)
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Pass-Through
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    income is taxed on the owner’s or members’ individual income
                    tax return
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Partnerships
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    Pass-Through
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    no entity-level tax; each partner reports their share of
                    income on their personal or business return
                  </Typography>
                </Paper>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Pass- Through Entities
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    4.4%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    Colorado-source income (if electing to pay the entity-level
                    tax under the Pass-Through Entity Tax Election)
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Tax- Exempt Organizations
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    Exempt
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    Generally, exempt but may owe tax on unrelated business
                    taxable income (UBTI)
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Estimated Tax payments for Colorado Businesses
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 19, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  Businesses in Colorado must make estimated tax payments if
                  they expect to owe{' '}
                  <span style={{ fontWeight: 600 }}>$1,000 or more</span>{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  in Colorado income tax for the year. Making these prepayments
                  helps you avoid underpayment penalties and interest.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Payment Deadlines
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      1<sup>st</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      April 15
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      2<sup>nd</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      June 15
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      3<sup>rd</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Sept 15
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      4<sup>th</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Dec 15
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Who should pay
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      C Corporations
                    </Typography>
                    <Typography variant="body1">
                      If the expected tax liability is{' '}
                      <span style={{ fontWeight: 600 }}> $1,000 or more,</span>{' '}
                      use{' '}
                      <span style={{ fontWeight: 600 }}>Form DR 0112EP</span> to
                      make estimated payments.
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      S Corporation & Partnerships
                    </Typography>
                    <Typography variant="body1">
                      Generally, not required to make entity-level estimated
                      payments unless they elect to pay under the{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Pass-Through Entity (PTE) tax election.
                      </span>
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      LLCs & Sole Proprietors
                    </Typography>
                    <Typography variant="body1">
                      Pay estimated taxes using{' '}
                      <span style={{ fontWeight: 600 }}> Form DR 0104EP</span>{' '}
                      (Individual Estimated Tax Payment Form) based on expected
                      income.
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid
              size={12}
              sx={{
                mt: 2,
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box
                component="div"
                sx={{
                  backgroundColor: '#f5efff',
                  borderLeft: '5px solid #45247e',
                  p: 2,
                  mb: 4,
                  borderRadius: 2,
                  textAlign: 'left',
                }}
              >
                <Typography variant="body1" sx={{ fontSize: 14, mt: 0 }}>
                  <span style={{ fontWeight: 600 }}> Missed Payments:</span>{' '}
                  Late or missed estimated payments may result in{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    penalties and interest
                  </span>{' '}
                  on underpaid amounts.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ pt: 2, mb: 5 }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 0,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Penalties and Interest for Business in Colorado
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { md: 18, sm: 16, xs: 16 },
                  textAlign: 'center',
                }}
              >
                If your business doesn’t pay the required tax by the original
                due date,
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                {'  '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  penalties and interest may apply—even if you’ve filed an
                  extension
                </span>
              </Typography>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 0 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Payment Penalty
                    </Typography>
                    <Typography variant="body1">
                      5% of the unpaid tax for the first month (or part of a
                      month) the payment is late,{' '}
                      <span style={{ fontWeight: 600 }}>
                        plus 0.5% for each additional month
                      </span>{' '}
                      the balance remains unpaid, up to a{' '}
                      <span style={{ fontWeight: 600 }}>maximum of 12%</span> of
                      the unpaid tax.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Filing Penalty
                    </Typography>
                    <Typography variant="body1">
                      For most business taxes, the penalty is the{' '}
                      <span style={{ fontWeight: 600 }}>
                        greater of $5 or 5% of the unpaid tax
                      </span>{' '}
                      for the first month,{' '}
                      <span style={{ fontWeight: 600 }}>
                        plus 0.5% for each additional month,
                      </span>{' '}
                      not to exceed{' '}
                      <span style={{ fontWeight: 600 }}>12% total.</span>
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Interest
                    </Typography>
                    <Typography variant="body1">
                      Interest accrues daily on any unpaid balance from the
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        original due date
                      </span>{' '}
                      until the tax is paid in full. The rate is adjusted
                      annually and published by the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Colorado Department of Revenue.
                      </span>
                    </Typography>
                  </Paper>
                </Box>
              </Stack>

              <Alert
                severity="info"
                icon={false}
                sx={{ mb: 3, borderLeft: '3px solid #0288d1' }}
              >
                <b>Tips:</b> Filing your extension and paying your estimated tax
                on time through{' '}
                <span style={{ fontWeight: 600 }}> TaxZerone</span> helps you
                avoid costly penalties and interest charges.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/state-help-img.webp" />
                  <source srcSet="/assets/images/state-help-img.png" />
                  <img
                    src="/assets/images/state-help-img.png"
                    alt="How TaxZerone can Help You?"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  How TaxZerone can Help You?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>
                  TaxZerone simplifies your business tax process from start to
                  finish — helping you stay compliant with both federal and
                  Colorado state tax requirements. While state business taxes
                  are filed directly through the Colorado Department of Revenue
                  (DOR), TaxZerone gives you the clarity and tools to handle
                  everything smoothly.
                </Typography>
                <Typography variant="body1">
                  Here’s how we help your Colorado business:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    Identify which{' '}
                    <span style={{ fontWeight: 600 }}>
                      Colorado business tax forms
                    </span>{' '}
                    your entity needs to file
                  </li>
                  <li>
                    Know your{' '}
                    <span style={{ fontWeight: 600 }}>
                      state deadlines and payment requirements
                    </span>{' '}
                  </li>
                  <li>
                    Stay updated on{' '}
                    <span style={{ fontWeight: 600 }}>
                      filing deadlines, extensions, and estimated payment
                      schedules
                    </span>{' '}
                  </li>
                  <li>
                    Access clear{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      guidance for extensions
                    </span>{' '}
                    by like Forms DR 0158-C, DR 0158-N, and DR 0158-F{' '}
                  </li>
                  <li>
                    Learn how to{' '}
                    <span style={{ fontWeight: 600 }}>
                      avoid late filing penalties and interest
                    </span>{' '}
                    with timely submissions{' '}
                  </li>
                </Box>
                <Typography variant="body1">
                  With<span style={{ fontWeight: 600 }}> TaxZerone,</span> you
                  can file your{' '}
                  <span style={{ fontWeight: 600 }}>federal tax forms</span>{' '}
                  confidently and get expert-backed guidance to ensure your
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Colorado state filings
                  </span>{' '}
                  are accurate and on time—keeping your business fully compliant
                  year-round.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to Simplify Your Business Tax Filing?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Stay compliant and stress-free with TaxZerone. File your federal forms
          online and get
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          guided support for your Colorado state requirements — all in one
          place.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=colorado`}
          >
            Start filing Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What Forms Does My Business Need to File in Colorado State?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1">
                      Colorado businesses are required to file specific tax
                      forms based on their entity type — including{' '}
                      <span style={{ fontWeight: 600 }}> Form DR 0104</span> and{' '}
                      <span style={{ fontWeight: 600 }}>Schedule C</span> for
                      sole proprietors,{' '}
                      <span style={{ fontWeight: 600 }}>Form DR 0106</span> and
                      <span style={{ fontWeight: 600 }}> DR 0106K</span> for
                      partnerships and multi-member LLCs,{' '}
                      <span style={{ fontWeight: 600 }}>
                        Form DR 0112, DR 0112EP,
                      </span>{' '}
                      and <span style={{ fontWeight: 600 }}>DR 0158-C</span> for
                      C corporations,{' '}
                      <span style={{ fontWeight: 600 }}>Form DR 0106</span> and{' '}
                      <span style={{ fontWeight: 600 }}>DR 0158-S </span> for S
                      corporations,{' '}
                      <span style={{ fontWeight: 600 }}>Form DR 0106</span> and{' '}
                      <span style={{ fontWeight: 600 }}>DR 0108</span> for
                      pass-through entities,{' '}
                      <span style={{ fontWeight: 600 }}>Form DR 0112</span> (for
                      unrelated business income) for tax-exempt organizations,{' '}
                      <span style={{ fontWeight: 600 }}>Form CR 0100</span> and
                      for employment and payroll taxes, and{' '}
                      <span style={{ fontWeight: 600 }}>
                        Forms DR 0200, DR 0100,
                      </span>{' '}
                      and <span style={{ fontWeight: 600 }}>DR 1093</span> for
                      additional Colorado business tax filings.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What happens if I don’t pay my taxes by the original due
                  date in Colorado?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 1 }}>
                      Even with an automatic extension to file, failing to pay
                      your taxes by the original due date will result in
                      penalties and interest. To avoid extra charges, pay the
                      estimated tax on time, even if you file later under
                      extension.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. How Can I Request an Extension for My Colorado Business?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      If you need additional time beyond the automatic
                      extension, you can submit the appropriate extension
                      payment form:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 0 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>Corporations:</span>{' '}
                        Form DR 0158-C{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Partnerships / S Corporations:
                        </span>{' '}
                        Form DR 0158-N
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Tax-Exempt Organizations:
                        </span>{' '}
                        Form DR 0158-F
                      </li>
                    </Box>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{ mb: 0, borderLeft: '3px solid rgb(102, 60, 0)' }}
                    >
                      <b>Note: </b> If you also need to extend your{' '}
                      <span style={{ fontWeight: 600 }}>
                        federal business tax return,
                      </span>{' '}
                      you can file{' '}
                      <Link
                        href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        IRS Form 7004
                      </Link>{' '}
                      online through{' '}
                      <span style={{ fontWeight: 600 }}>TaxZerone. </span>
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What Happens If I Don’t Pay My Taxes by the Original Due
                  Date?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      Even if you receive an extension to file, failing to pay
                      your taxes on time may lead to penalties and daily
                      accruing interest. Make sure to submit payments by the
                      original due date to stay compliant and avoid extra costs.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default BusinessStateColorado;
